/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('WaiverServiceApi', ($http, ApiErrorService) => {
    return {
        waiverWithNotes: waiverWithNotes,
        getWaiver: getWaiver,
        requestWaiver: requestWaiver,
        decideWaiver: decideWaiver,
        getDecidedWaiver: getDecidedWaiver,
        removeWaiver: removeWaiver
    };
    function waiverWithNotes(req) {
        return $http.post(`api/Waiver/WaiverWithNotes`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getWaiver(req) {
        return $http.post(`api/Waiver/GetWaiver`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function requestWaiver(req) {
        return $http.post(`api/Waiver/RequestWaiver`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function decideWaiver(waiverDecision) {
        return $http.post(`api/Waiver/DecideWaiver`, waiverDecision)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getDecidedWaiver(waiverDecision) {
        return $http.post(`api/Waiver/GetDecidedWaiver`, waiverDecision)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function removeWaiver(waiverId, testId) {
        return $http.post(`api/Waiver/RemoveWaiver?waiverId=${waiverId}&testId=${testId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
